import React from 'react';
import { followGroupRequest } from 'entity/group/groupRedux';
import { useDispatch } from 'react-redux';
import Button from 'seedly-component-library/button-new';
import { useIsSignedIn } from 'entity/user/userHooks';
import { openLoginModal } from 'dispatcher/modalDispatcher';
import { LOGIN_MODAL, TYPES } from 'constants/login';

interface OwnProps {
  followedByCurrentUser: boolean;
  id: number;
  isLoading: boolean;
}

const JoinButton = (props: OwnProps) => {
  const { followedByCurrentUser, id, isLoading } = props;
  const dispatch = useDispatch();
  const isSignedIn = useIsSignedIn();

  return (
    <Button
      variant={followedByCurrentUser ? 'primary' : 'outline'}
      onClick={() => {
        if (isSignedIn) {
          dispatch(followGroupRequest(id));
        } else {
          sessionStorage.setItem('new-group', JSON.stringify(id));
          dispatch(openLoginModal(LOGIN_MODAL[TYPES.JOIN_GROUP]));
        }
      }}
      data-testid="join-group-button"
      isLoading={isLoading}
    >
      {followedByCurrentUser ? 'Joined' : 'Join'}
    </Button>
  );
};

export default JoinButton;
